import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';
import ProgressBar from 'react-bootstrap/ProgressBar';
import img1 from '../../assets/QU_ispa.jpg';
import { useEffect, useRef, useState } from 'react';
import './about.css';

function AppAbout() {
  const html = 80;
  const responsive = 95;
  const photoshop = 60;

  const [visible, setVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return;
      const rect = sectionRef.current.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // para verificar na primeira renderização

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section
      ref={sectionRef}
      id="about"
      className="block about-block"
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(50px)',
        transition: 'opacity 0.7s cubic-bezier(0.4,0,0.2,1), transform 0.7s cubic-bezier(0.4,0,0.2,1)',
        pointerEvents: visible ? 'auto' : 'none',
        minHeight: '70vh',
        margin: '40px 0',
        padding: '40px 0',
        border: 'none'
      }}
    >
      <Container fluid="md">
       <div
        className="title-holder-modern py-5 px-3 px-md-4"
        style={{
          animation: visible ? 'slideInDown 1s cubic-bezier(0.4,0,0.2,1)' : 'none',
          opacity: visible ? 1 : 0,
          textAlign: 'center',
          marginBottom: '2.5rem',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <h2
          className="section-title"
          style={{
            color: '#00761F',
            fontWeight: '700',
            fontSize: '2.5rem',
            textTransform: 'uppercase',
            marginBottom: '14px'
          }}
        >
          Quem Somos & Nossa Missão
        </h2>
        <div
          className="section-subtitle"
          style={{
            fontWeight: '500',
            color: '#444',
            fontSize: '1.25rem',
            letterSpacing: '0.5px'
          }}
        >
          Excelência Acadêmica, Inovação e Impacto Social
        </div>
        <div
          className="section-underline"
          style={{
            marginTop: '20px',
            width: '60px',
            height: '4px',
            backgroundColor: '#00761F',
            borderRadius: '2px'
          }}
        ></div>
      </div>


        <Row className="align-items-center">
          <Col sm={12} md={6}>
            <div
              style={{
                animation: visible ? 'slideInLeft 1.1s cubic-bezier(0.4,0,0.2,1)' : 'none',
                opacity: visible ? 1 : 0,
                display: 'flex',
                justifyContent: 'center'
              }}
            >
              <Image
                className='image_Quem'
                src={img1}
                rounded
                fluid
                style={{
                  maxWidth: 380,
                  boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.18)',
                  borderRadius: '18px',
                  border: '4px solid #fff'
                }}
                alt="Instituto Superior Politécnico Atlântida"
              />
            </div>
          </Col>
          <Col sm={12} md={6}>
          <div
            style={{
              animation: visible ? 'slideInUpRight 1.2s cubic-bezier(0.4,0,0.2,1)' : 'none',
              opacity: visible ? 1 : 0,
              background: 'linear-gradient(135deg, rgba(255,255,255,0.95), #f9f9f9)',
              borderRadius: '18px',
              padding: '32px 28px',
              boxShadow: '0 12px 32px rgba(0, 0, 0, 0.06)',
              backdropFilter: 'blur(3px)',
              border: '1px solid #e0e0e0',
              transition: 'all 0.3s ease'
            }}
          >
            <p style={{
              fontSize: '1.1rem',
              color: '#37474f',
              marginBottom: '18px',
              lineHeight: 1.75,
              fontWeight: 400,
              textAlign: 'justify'
            }}>
              O <strong>Instituto Superior Politécnico Atlântida</strong>, fundado em 2012 e legalizado pelo Decreto Presidencial Nº 168, está localizado em Luanda. A instituição é dotada de autonomia estatutária pedagógica, científica, cultural e administrativa.
            </p>
            <p style={{
              fontSize: '1.1rem',
              color: '#37474f',
              marginBottom: '24px',
              lineHeight: 1.75,
              fontWeight: 400,
              textAlign: 'justify'
            }}>
              Estruturado em quatro grandes áreas do conhecimento, o ISPA oferece <strong>15 cursos de graduação</strong>, distribuídos entre as Ciências da Saúde, Engenharias e Tecnologias, Gestão e Ciências Sociais.
            </p>

            {/* Barra de Progresso 1 */}
            <div className="progress-block" style={{ marginBottom: 22 }}>
              <h4 style={{
                fontWeight: 600,
                color: '#0d47a1',
                fontSize: '1.05rem',
                marginBottom: 6
              }}>
                Engenharia Informática
              </h4>
              <ProgressBar
                now={html}
                label={`${html}%`}
                animated
                variant="info"
                style={{
                  height: 18,
                  fontWeight: 500,
                  fontSize: '0.95rem',
                  background: '#e3f2fd',
                  borderRadius: '10px'
                }}
              />
            </div>

            {/* Barra de Progresso 2 */}
            <div className="progress-block" style={{ marginBottom: 22 }}>
              <h4 style={{
                fontWeight: 600,
                color: '#2e7d32',
                fontSize: '1.05rem',
                marginBottom: 6
              }}>
                Análises Clínicas
              </h4>
              <ProgressBar
                now={responsive}
                label={`${responsive}%`}
                animated
                variant="success"
                style={{
                  height: 18,
                  fontWeight: 500,
                  fontSize: '0.95rem',
                  background: '#e8f5e9',
                  borderRadius: '10px'
                }}
              />
            </div>

            {/* Barra de Progresso 3 */}
            <div className="progress-block">
              <h4 style={{
                fontWeight: 600,
                color: '#f9a825',
                fontSize: '1.05rem',
                marginBottom: 6
              }}>
                Gestão de Recursos Humanos
              </h4>
              <ProgressBar
                now={photoshop}
                label={`${photoshop}%`}
                animated
                variant="warning"
                style={{
                  height: 18,
                  fontWeight: 500,
                  fontSize: '0.95rem',
                  background: '#fffde7',
                  borderRadius: '10px'
                }}
              />
            </div>
          </div>
        </Col>

        </Row>
      </Container>

      <style>
        {`
          @keyframes slideInLeft {
            0% { transform: translateX(-80px); opacity: 0; }
            100% { transform: translateX(0); opacity: 1; }
          }

          @keyframes slideInDown {
            0% { transform: translateY(-60px); opacity: 0; }
            100% { transform: translateY(0); opacity: 1; }
          }

          @keyframes slideInUpRight {
            0% { transform: translate(60px, 60px); opacity: 0; }
            100% { transform: translate(0, 0); opacity: 1; }
          }
        `}
      </style>
    </section>
  );
}

export default AppAbout;
